// @ts-nocheck
import useIdToFindResourceList from './use-id-to-find-resource-list.js'

/**
 * findResource
 * @param {{resource: Object, id: Number, categoryId: Number}} param0
 */
export default function findResource({ resource, id, categoryId }) {
  const resourceList = useIdToFindResourceList({
    resource,
    id: categoryId
  })
  if (resourceList && resourceList.length > 0) {
    return resourceList.find(item => item.id === id) || null
  }
  return null
}

/**
 * findDefaultResource 寻找默认resource
 * @param  {Object} resource 资源
 * @param  {Number} categoryId category id
 */
export function findDefaultResource({ resource, categoryId }) {
  const resourceList = useIdToFindResourceList({
    resource,
    id: categoryId
  })
  if (resourceList && resourceList.length > 0) {
    return resourceList.find(item => item.is_default === 1) || null
  }
  return null
}
/**
 * findBasicResource 寻找基础包resource
 * @param  {Object} resource 资源
 * @param  {Number} categoryId category id
 */
export function findBasicResource({ resource, categoryId }) {
  const resourceList = useIdToFindResourceList({
    resource,
    id: categoryId
  })
  if (resourceList && resourceList.length > 0) {
    return resourceList.find(item => item.is_basic === 1) || null
  }
  return null
}
